import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { login } from '../api';

class LoginContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      form: { 
        username: '',
        password: ''
      },
      error: null
    }
    this.onChange = this.onChange.bind(this)
    this.login = this.login.bind(this)
  }

  login(e) {
    e.preventDefault()
    console.log('logging in', this.state.form)
    const loginPromise = login(this.state.form)
    loginPromise.then(user => {
      console.log('success', user)
      window.localStorage.setItem('username', user.data.username)
      window.localStorage.setItem('token', user.data.token)
      window.localStorage.setItem('token_expires', user.data.token_expires)
      this.setState({ error: null })
      this.props.history.push('/')
    }).catch(err => {
      console.log('errrrr', err, err.response)
      this.setState({ error: err.response.data })
    })
  }

  onChange(e) {
    switch (e.target.id) {
      case 'username':
        this.setState({ ...this.state, form: { ...this.state.form, username: e.target.value }})
        break
      case 'password':
        this.setState({ ...this.state, form: { ...this.state.form, password: e.target.value }})
        break
      default:
    }
  }

  render() {
    const error = this.state.error
    return (
      <Form onSubmit={this.login}>
        <FormGroup>
          <Label>Username</Label>
          <Input type="text" name="username" id="username" placeholder="Username" onChange={this.onChange} />
        </FormGroup>
        <FormGroup>
          <Label>Username</Label>
          <Input type="password" name="password" id="password" placeholder="Password" onChange={this.onChange} />
        </FormGroup>
        <Button color="primary">Login</Button>
        <p>&nbsp;</p>
        {error && (
          <Alert color="warning">
            {this.state.error}
          </Alert>
        )}
      </Form>
    )
  }
}

export default withRouter(LoginContainer)
